module.exports = __webpack_public_path__ + "static/media/i_featured_concord.85393eb2.svg";